import React, { ReactElement } from 'react';

import { LinkButton, StandardButton } from '@eika/button';
import IconTypes from '@eika/icon/lib/IconTypes';

interface Props {
    showPrevious?: boolean;
    showNext?: boolean;
    nextButtonType?: 'submit' | 'reset' | 'button';
    previousChangeEvent?: () => void;
    nextChangeEvent?: () => void;
    nextButtonName?: string | ReactElement;
    previousButtonName?: string;
    dataTrackId?: string;
}

const StepButtons = ({
    showPrevious,
    showNext,
    nextButtonType,
    previousChangeEvent,
    nextChangeEvent,
    nextButtonName = 'Neste',
    previousButtonName = 'Tilbake',
    dataTrackId,
}: Props): JSX.Element => (
    <div className="credit-card-application-step-buttons">
        {showPrevious && (
            <LinkButton
                className="previous-button"
                onClick={previousChangeEvent && previousChangeEvent}
                icon={IconTypes.LITEN_PIL_VENSTRE}
            >
                {previousButtonName}
            </LinkButton>
        )}
        {showNext && (
            <StandardButton
                className="next-button"
                type={nextButtonType}
                onClick={nextChangeEvent && nextChangeEvent}
                data-track-id={dataTrackId}
            >
                {nextButtonName}
            </StandardButton>
        )}
    </div>
);

export default StepButtons;
